import { useTranslate, useNavigation } from '@pankod/refine-core'

import { Row, Col, AntdLayout, Card, Typography, Form, Input, Button, message } from '@pankod/refine-antd'

import { changePassword } from 'users'
const { Text, Title } = Typography
export interface IForgotPassword {
  email: string
  newPassword: string
}

export const ForgotPasswordPage: React.FC = () => {
  const [form] = Form.useForm<IForgotPassword>()
  const t = useTranslate()
  const { push } = useNavigation()
  const CardTitle = (
    <div style={{ textAlign: 'center' }}>
      <img style={{ width: '150px' }} src="/images/logo.jpg" width="100%" />
    </div>
  )

  const success = (msg: string, type: string) => {
    form.resetFields()
    if (type === 'success') {
      message.success(msg)
    } else message.error(msg)
  }

  return (
    <AntdLayout>
      <Row
        justify="center"
        align="middle"
        style={{
          height: '100vh',
        }}
      >
        <Col xs={22}>
          <div style={{ maxWidth: '408px', margin: 'auto' }}>
            <Card title={CardTitle} headStyle={{ borderBottom: 0 }}>
              <Form<IForgotPassword>
                layout="vertical"
                form={form}
               
                requiredMark={false}
              >
                <Form.Item name="email" label={t('pages.forgotPassword.email', 'Email')} rules={[{ required: true }]}>
                  <Input size="large" />
                </Form.Item>
                <Form.Item
                  name="newPassword"
                  label={t('pages.forgotPassword.newPassword', 'New Password')}
                  rules={[{ required: true }]}
                  style={{ marginBottom: '12px' }}
                >
                  <Input type="password" size="large" />
                </Form.Item>

                <div style={{ float: 'right' }}>
                  <Button type="primary" htmlType="submit">
                    Save
                  </Button>
                </div>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
    </AntdLayout>
  )
}
